// card
export const MANAGE_INTEGRATIONS_CARD_SYNCED = "si.manage-integrations.card.status.synced";
export const MANAGE_INTEGRATIONS_CARD_SYNCING = "si.manage-integrations.card.status.syncing";
export const MANAGE_INTEGRATIONS_CARD_CONFIGURED = "si.manage-integrations.card.status.configured";
export const MANAGE_INTEGRATIONS_CARD_NOT_CONFIGURED = "si.manage-integrations.card.status.not-configured";
export const SL_ALL_LISTS_LABEL = "si.management.sl.section.allLists";
export const SL_LIST_ITEM_LABEL = "si.management.sl.section.listItemLabel";
export const MANAGE_INTEGRATIONS_CARD_ACTIVATE = "si.common.activate";
export const MANAGE_INTEGRATIONS_CARD_MANAGE = "si.common.manage";
export const MANAGE_INTEGRATIONS_CARD_CONFIGURE = "si.common.configure";
export const MANAGE_INTEGRATIONS_CARD_UPGRADE = "si.manage-integrations.explore-more";
export const MANAGE_INTEGRATIONS_REQUEST_ADMIN_BUTTON_TEXT = "si.management.request-admin.button.text";
export const MANAGE_INTEGRATIONS_REQUEST_ADMIN_BUTTON_SENT = "si.management.request-admin.button.sent";

export const MANAGE_INTEGRATIONS_CARD_PROSPECTING_TAG = "si.manage-integrations.card.tag.prospecting";
export const MANAGE_INTEGRATIONS_CARD_ENRICHMENT_TAG = "si.manage-integrations.card.tag.enrichment";
export const MANAGE_INTEGRATIONS_CARD_ENGAGEMENT_TAG = "si.manage-integrations.card.tag.engagement";

// APIs & Webhooks
export const MANAGE_INTEGRATIONS_APIS_TITLE = "si.manage-integrations.apis-webhooks.api.title";
export const MANAGE_INTEGRATIONS_WEBHOOKS_TITLE = "si.manage-integrations.apis-webhooks.webhooks.title";

// API
export const MY_INTEGRATIONS_API_TECHNOLOGIES_TITLE = "si.manage-integrations.api.technologies.title";
export const MY_INTEGRATIONS_API_TECHNOLOGIES_DESCRIPTION = "si.manage-integrations.api.technologies.description";
export const MY_INTEGRATIONS_API_LEAD_ENRICHMENT_TITLE = "si.manage-integrations.api.leadEnrichment.title";
export const MY_INTEGRATIONS_API_LEAD_ENRICHMENT_DESCRIPTION = "si.manage-integrations.api.leadEnrichment.description";
export const MY_INTEGRATIONS_API_CONTACTS_TITLE = "si.manage-integrations.api.contacts.title";
export const MY_INTEGRATIONS_API_CONTACTS_DESCRIPTION = "si.manage-integrations.api.contacts.description";
export const MY_INTEGRATIONS_API_AI_OUTREACH_TITLE = "si.manage-integrations.api.aiOutreach.title";
export const MY_INTEGRATIONS_API_AI_OUTREACH_DESCRIPTION = "si.manage-integrations.api.aiOutreach.description";
export const MY_INTEGRATIONS_API_SIGNALS_REST_API_TITLE = "si.manage-integrations.api.signalsRestApi.title";
export const MY_INTEGRATIONS_API_SIGNALS_REST_API_DESCRIPTION = "si.manage-integrations.api.signalsRestApi.description";
export const MY_INTEGRATIONS_API_SIGNALS_REST_API_CONFIGURED_TITLE =
    "si.manage-integrations.api.signalsRestApi.configured.title";

// Webhooks: Signals webhook card
export const WEBHOOKS_SIGNALS_TITLE = "si.manage-integrations.webhooks.signals.title";
export const WEBHOOKS_SIGNALS_TRACKED_DOMAINS = "si.manage-integrations.webhooks.signals.tracked-domains";
export const WEBHOOKS_SIGNALS_ACTIVE_SIGNALS = "si.manage-integrations.webhooks.signals.active-signals";
export const MY_INTEGRATIONS_SIGNALS_WEBHOOKS_EMPTY_TEXT = "si.manage-integrations.webhooks.signals.empty-text";

// Webhooks: Find new companies card
export const WEBHOOKS_FIND_COMPANIES_TITLE = "si.manage-integrations.webhooks.find-companies.title";
export const WEBHOOKS_FIND_COMPANIES_TRACKED_SEARCHES =
    "si.manage-integrations.webhooks.find-companies.tracked-searches";
export const WEBHOOKS_FIND_COMPANIES_NEW_COMPANIES = "si.manage-integrations.webhooks.find-companies.new-companies";
export const MY_INTEGRATIONS_FIND_COMPANIES_WEBHOOKS_EMPTY_TEXT =
    "si.manage-integrations.webhooks.find-companies.empty-text";

// Webhooks: shared
export const WEBHOOKS_LAST_DELIVERY = "si.manage-integrations.webhooks.last-delivery";
export const WEBHOOKS_DISABLED_TOOLTIP_LOADING = "si.management.disabled-tooltip.loading";

export const WEBHOOKS_FIND_COMPANIES_MANAGE_DISABLED_TOOLTIP =
    "si.management.saved-search-webhooks.card.manage-tooltip";
export const WEBHOOKS_FIND_COMPANIES_CONFIGURE_DISABLED_TOOLTIP =
    "si.management.saved-search-webhooks.card.connect-tooltip";

// mcp
export const MCP_CLAUDE_TITLE = "si.common.claude";
export const MCP_CURSOR_TITLE = "si.common.cursor";
export const MCP_COPILOT_TITLE = "si.common.copilot";
export const MCP_CHAT_GPT_TITLE = "si.common.chatgpt";
export const MCP_MANUS_TITLE = "si.common.manus";
export const MCP_CLAUDE_DESCRIPTION = "si.manage-integrations.mcp.card.claude.description";
export const MCP_CURSOR_DESCRIPTION = "si.manage-integrations.mcp.card.cursor.description";
export const MCP_COPILOT_DESCRIPTION = "si.manage-integrations.mcp.card.copilot.description";
export const MCP_CHAT_GPT_DESCRIPTION = "si.manage-integrations.mcp.card.chat-gpt.description";
export const MCP_MANUS_DESCRIPTION = "si.manage-integrations.mcp.card.manus.description";

// mcp banner
export const MCP_CONNECTION_BANNER_TITLE = "si.manage-integrations.mcp.connection-banner.title";
export const MCP_CONNECTION_BANNER_TEXT = "si.manage-integrations.mcp.connection-banner.text";
export const MCP_CONNECTION_BANNER_GUID_BUTTON = "si.manage-integrations.mcp.connection-banner.guide-button.text";
export const MCP_CONNECTION_BANNER_COPY_BUTTON = "si.common.copy";
export const MCP_CONNECTION_BANNER_COPIED_BUTTON = "si.common.copied";

// card types
export const CARD_TYPE_LABEL_CRM = "si.manage-integrations.card.type.crm";
export const CARD_TYPE_LABEL_WEBHOOK = "si.manage-integrations.card.type.webhook";
export const CARD_TYPE_LABEL_MCP = "si.manage-integrations.card.type.mcp";
export const CARD_TYPE_LABEL_API = "si.manage-integrations.card.type.api";

// my integrations
export const MY_INTEGRATIONS_ADD_BUTTON = "si.manage-integrations.my-integrations.add-button";
export const MY_INTEGRATIONS_FILTER_ANY_TYPE = "si.manage-integrations.my-integrations.filter.any-type";
export const MY_INTEGRATIONS_ADD_OPTION_MCP = "si.manage-integrations.my-integrations.add-option.mcp";

// empty state
export const MY_INTEGRATIONS_EMPTY_STATE_CONNECT_CRM = "si.manage-integrations.my-integrations.empty-state.connect-crm";
export const MY_INTEGRATIONS_EMPTY_STATE_CONNECT_WEBHOOK =
    "si.manage-integrations.my-integrations.empty-state.connect-webhook";
export const MY_INTEGRATIONS_EMPTY_STATE_PLUGIN_MCP = "si.manage-integrations.my-integrations.empty-state.plugin-mcp";
export const MY_INTEGRATIONS_EMPTY_STATE_CONNECT_API = "si.manage-integrations.my-integrations.empty-state.connect-api";

// crm Salesforce
export const MY_INTEGRATIONS_SF_CRM_EMPTY_TEXT = "si.manage-integrations.crm.salesforce.empty-text";
export const MY_INTEGRATIONS_SF_CRM_CONNECT_TEXT = "si.manage-integrations.crm.salesforce.connect-button.label";
// crm Hubspot
export const MY_INTEGRATIONS_HS_CRM_EMPTY_TEXT = "si.manage-integrations.crm.hubspot.empty-text";
// crm Dynamics
export const MY_INTEGRATIONS_DYNAMICS_CRM_EMPTY_TEXT = "si.manage-integrations.crm.dynamics.empty-text";
export const MY_INTEGRATIONS_HS_CRM_CONNECT_TEXT = "si.manage-integrations.crm.hubspot.connect-button.label";

// connectors
export const CONNECTOR_HUBSPOT_TITLE = "si.manage-integrations.connector.hubspot.title";
export const CONNECTOR_HUBSPOT_DESCRIPTION = "si.manage-integrations.connector.hubspot.description";
export const CONNECTOR_GOOGLE_SHEETS_TITLE = "si.manage-integrations.connector.google-sheets.title";
export const CONNECTOR_GOOGLE_SHEETS_DESCRIPTION = "si.manage-integrations.connector.google-sheets.description";
